import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { IconButton, TableBody, TableCell } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import React from 'react';

interface IItem {
	id: number;
	title: string;
	description: string;
	link: string;
	image_id?: any;
	mobile_image_id?: any;
	mobile_image?: any;
	image: any;
	imageMobile: any;
}

interface Props {
	item: IItem;
	handleEditItem: (id: number) => void;
	handleDeleteItem: (id: number) => void;
}

const BlockItem: React.FC<Props> = ({ item, handleEditItem, handleDeleteItem }) => {
	const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: item.id });

	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
	};

	return (
		<TableBody style={style} ref={setNodeRef} {...attributes} {...listeners}>
			<TableCell align="center">{item.id}</TableCell>
			<TableCell align="center">{item.title}</TableCell>
			<TableCell align="center">{item.link}</TableCell>
			<TableCell>
				<img className="w-12" src={item?.image} alt={item?.image} />
			</TableCell>
			<TableCell>
				<img className="w-12" src={item?.mobile_image} alt={item.mobile_image} />
			</TableCell>
			<TableCell>
				<IconButton onClick={() => handleEditItem(item?.id)}>
					<EditIcon className="text-text-secondary" />
				</IconButton>
				<IconButton onClick={() => handleDeleteItem(item?.id)}>
					<DeleteOutlineIcon className="text-text-secondary" />
				</IconButton>
			</TableCell>
		</TableBody>
	);
};

export default BlockItem;
